import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const PercentIcon = _ref => {
  let {
      size = "13",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M16.8024 3.19757C17.1075 3.50267 17.1075 3.99733 16.8024 4.30243L4.30243 16.8024C3.99733 17.1075 3.50267 17.1075 3.19757 16.8024C2.89248 16.4973 2.89248 16.0027 3.19757 15.6976L15.6976 3.19757C16.0027 2.89248 16.4973 2.89248 16.8024 3.19757Z",
    fill: color
  }), __jsx("path", {
    d: "M5.625 7.5C4.58947 7.5 3.75 6.66053 3.75 5.625C3.75 4.58947 4.58947 3.75 5.625 3.75C6.66053 3.75 7.5 4.58947 7.5 5.625C7.5 6.66053 6.66053 7.5 5.625 7.5ZM5.625 8.75C7.35089 8.75 8.75 7.35089 8.75 5.625C8.75 3.89911 7.35089 2.5 5.625 2.5C3.89911 2.5 2.5 3.89911 2.5 5.625C2.5 7.35089 3.89911 8.75 5.625 8.75Z",
    fill: color
  }), __jsx("path", {
    d: "M14.375 16.25C13.3395 16.25 12.5 15.4105 12.5 14.375C12.5 13.3395 13.3395 12.5 14.375 12.5C15.4105 12.5 16.25 13.3395 16.25 14.375C16.25 15.4105 15.4105 16.25 14.375 16.25ZM14.375 17.5C16.1009 17.5 17.5 16.1009 17.5 14.375C17.5 12.6491 16.1009 11.25 14.375 11.25C12.6491 11.25 11.25 12.6491 11.25 14.375C11.25 16.1009 12.6491 17.5 14.375 17.5Z",
    fill: color
  }));
};
export default PercentIcon;